import React from 'react';

function Footer() {
  return (
    <div className='p-4 bg-dark text-white text-center d-flex align-items-center justify-content-center'>
      <p className='pt-3'>website made with love</p>
      <i className='fas fa-heart fa-2x text-danger ml-3 '></i>
    </div>
  );
}

export default Footer;
